import React from 'react';
import style from './index.module.scss';

const NmckMedicalDevicesCalculationInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Расчет НМЦК на медицинские изделия</h1>
    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Обосновать размер НМЦК с учетом <strong>цены самого изделия, стоимости расходных материалов (РМ)</strong> и{' '}
          <strong>услуг по техническому обслуживанию (ТО)</strong> на весь <strong>гарантийный срок</strong>, а также
          применить корректную методику в зависимости от вида медицинского изделия.
        </div>
      </div>
    </div>
  </>
);

export default NmckMedicalDevicesCalculationInfo;
